/**
 * @class CallsBackendProvider
 */
function CallsBackendProvider() {
    let callsUrl;

    /**
     * @param {String} url
     */
    this.setBDCUrl = function(url) {
        callsUrl = url;
    };

    this.$get = [
        '$http',
        function($http) {
            let self = {};

            self.getCalls = function(phone, from, to) {
                return $http.get(`${callsUrl}aircall/calls?phone_number=${encodeURIComponent(phone)}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`).then(function(res) {
                    return res.data;
                });
            };

            return self;
        }
    ];
}

angular.module('app.prospection.store.callsBackend', []).provider('callsBackend', CallsBackendProvider);
